var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightTakeoffGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_679_25097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5354 26.163L21.9496 24.7487L19.8283 15.5564L23.7174 11.6673C24.3043 11.0804 24.3043 10.1328 23.7174 9.54594C23.1305 8.95905 22.183 8.95905 21.5961 9.54594L17.707 13.435L8.5146 11.3137L7.10038 12.7279L14.525 16.617L10.6359 20.5061L8.16104 20.1525L7.10038 21.2132L10.2824 22.981L12.0501 26.163L13.1108 25.1023L12.7572 22.6274L16.6463 18.7383L20.5354 26.163Z",
    fill: "#434455"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_679_25097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16.9999) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightTakeoffGrey);
export default __webpack_public_path__ + "static/media/flight-takeoff-grey.871aacba0c248ac5663abf4bd635a587.svg";
export { ForwardRef as ReactComponent };